export const TRANSLATION_GROUP_FORGOT_PASSWORD = Symbol('forgot-password');

export const FORGOT_PASSWORD_EMAIL_ROUTE_NAME = Symbol('forgot-password.email');
export const FORGOT_PASSWORD_CONFIRM_TOKEN_ROUTE_NAME = Symbol('forgot-password.confirm-token');
export const FORGOT_PASSWORD_ENTER_PASSWORD_ROUTE_NAME = Symbol('forgot-password.enter-password');
export const FORGOT_PASSWORD_DONE_ROUTE_NAME = Symbol('forgot-password.done');

export const FORGOT_PASSWORD_EMAIL_URL = 'password';
export const FORGOT_PASSWORD_EMAIL_MUTATION_KEY = 'forgot-password.email';

export const FORGOT_PASSWORD_CONFIRMATION_URL = 'password/edit';
export const FORGOT_PASSWORD_CONFIRMATION_MUTATION_KEY = 'forgot-password.confirm';

export const FORGOT_PASSWORD_ENTER_URL = 'password';
export const FORGOT_PASSWORD_ENTER_MUTATION_KEY = 'forgot-password.enter';
